import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface UploadCardProps {
  title: string;
  children: React.ReactNode;
}

/**
 * `h2` rather than the `h6` MUI's `variant="h6"` produced — the level now
 * follows the page's `h1`, but it stays a heading so the outline is unchanged.
 */
const UploadCard: React.FC<UploadCardProps> = ({ title, children }) => (
  <Card>
    <CardContent className="p-6">
      <h2 className="revy-cjk mb-3 text-base font-semibold leading-[1.5] tracking-tight">
        {title}
      </h2>
      {children}
    </CardContent>
  </Card>
);

export default UploadCard;
